export enum AdminUserRole {
  SUPERUSER = 'SUPERUSER',
  HR = 'HR',
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  DEVELOPER = 'DEVELOPER'
}